import { Chip } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import UpdateIcon from '@mui/icons-material/Update';
import { MeetingBookingStatus } from 'generated-graphql/types';
import {
  calendarBookingStatusText,
  calendarBookingStatusType
} from '../utils/calendarBookingUtils';
import { NoteTakerStatus } from 'generated-graphql/graphql';
import { badgeChipSx } from 'theme/components/chip';

const iconByStatus = {
  [MeetingBookingStatus.Scheduled]: <CheckIcon fontSize="small" />,
  [MeetingBookingStatus.Rescheduled]: <CheckIcon fontSize="small" />,
  [MeetingBookingStatus.ReschedulingRequested]: <UpdateIcon fontSize="small" />,
  [MeetingBookingStatus.Cancelled]: <CloseIcon fontSize="small" />
};

type Props = {
  status?: MeetingBookingStatus | null;
  noteTakerStatus?: NoteTakerStatus | null;
  showIcon?: boolean;
};

export const CalendarMeetingStatusChip: React.FC<Props> = ({
  status,
  noteTakerStatus,
  showIcon = false
}) => {
  if (!status) {
    return null;
  }

  if (noteTakerStatus === NoteTakerStatus.Available) {
    return <Chip label="Completed" sx={badgeChipSx} />;
  }

  return (
    <Chip
      label={calendarBookingStatusText[status]}
      color={calendarBookingStatusType[status]}
      icon={showIcon ? iconByStatus[status] : undefined}
      sx={badgeChipSx}
    />
  );
};
